/* START_MODULE_CONTRACT
 * PURPOSE: Корневой компонент приложения: провайдеры, роутер и карта маршрутов (public/private).
 * SCOPE: AuthProvider, BrowserRouter, определение всех Route.
 * DEPENDS: M-FE-AUTH, M-FE-FEATURE-TOGGLE
 * LINKS: M-FE-APP, M-FE-AUTH, UC-022
 * ROLE: RUNTIME
 * END_MODULE_CONTRACT
 *
 * START_MODULE_MAP
 * App - корневой компонент с деревом маршрутов.
 * END_MODULE_MAP
 *
 * START_CHANGE_SUMMARY
 * LAST_CHANGE: 2026-08-10 - UC-022 FeatureToggleProvider + /admin/feature-toggles.
 * LAST_CHANGE: 2026-07-13 - AppLocalizationProvider для MUI X DatePicker.
 * LAST_CHANGE: 2026-07-13 - ThemeProvider с appTheme для стабильного UX полей ввода.
 * END_CHANGE_SUMMARY
 */

import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import { appTheme } from './theme/appTheme';
import AppLocalizationProvider from './components/AppLocalizationProvider';
import { AuthProvider } from './context/AuthContext';
import { FeatureToggleProvider } from './context/FeatureToggleContext';
import PublicLayout from './layouts/PublicLayout';
import PrivateLayout from './layouts/PrivateLayout';
import PrivateRoute from './components/PrivateRoute';
import LoginPage from './pages/LoginPage';
import RegisterPage from './pages/register/RegisterPage';
import ProfilePage from './pages/ProfilePage';
import ProjectPage from './pages/projects/ProjectPage';
import TimelinePage from './pages/timeline/TimelinePage';
import FeaturePage from './pages/features/FeaturePage';
import ProjectRolePage from './pages/project-roles/ProjectRolePage';
import EmployeePage from './pages/employees/EmployeePage';
import AdminUsersPage from './pages/admin/AdminUsersPage';
import FeatureTogglesPage from './pages/feature-toggles/FeatureTogglesPage';

/* START_METHOD_App */
/* START_CONTRACT: App
 * PURPOSE: Собрать провайдеры и маршруты приложения.
 * INPUTS: нет.
 * OUTPUTS: { JSX.Element - дерево роутинга }.
 * SIDE_EFFECTS: нет.
 * LINKS: M-FE-APP, M-FE-AUTH
 * END_CONTRACT: App
 */
export default function App() {
  return (
    <ThemeProvider theme={appTheme}>
      <AppLocalizationProvider>
        <AuthProvider>
        <FeatureToggleProvider>
        <CssBaseline />
        <BrowserRouter>
          <Routes>
            <Route element={<PublicLayout />}>
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
            </Route>

            <Route element={<PrivateRoute />}>
              <Route element={<PrivateLayout />}>
                <Route path="/projects" element={<ProjectPage />} />
                <Route path="/projects/:projectId/timeline" element={<TimelinePage />} />
                <Route path="/projects/:projectId/features" element={<FeaturePage />} />
                <Route path="/projects/:projectId/roles" element={<ProjectRolePage />} />
                <Route path="/projects/:projectId/employees" element={<EmployeePage />} />
                <Route path="/user/info" element={<ProfilePage />} />
                <Route path="/admin/users" element={<AdminUsersPage />} />
                <Route path="/admin/feature-toggles" element={<FeatureTogglesPage />} />
              </Route>
            </Route>

            <Route path="/" element={<Navigate to="/login" replace />} />
            <Route path="*" element={<Navigate to="/login" replace />} />
          </Routes>
        </BrowserRouter>
        </FeatureToggleProvider>
        </AuthProvider>
      </AppLocalizationProvider>
    </ThemeProvider>
  );
}
/* END_METHOD_App */
